import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import {
  saveToGlobalState,
  getStoredData,
  removeSpecificData,
} from "../../utils/localStorage";

const API_URL = process.env.REACT_APP_API_URL;
//const API_URL = "";

export default function UseLogin({ setShowLoginModal, navigate }) {
  const { setUser, setAccessToken } = useAuth();

  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const dataStorage = getStoredData();

  const handleLogin = async () => {
    if (!email.trim() || !senha.trim()) {
      setError("Por favor, preencha todos os campos!");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const res = await fetch(`${API_URL}/api/auth/login/`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, senha }),
      });

      const data = await res.json();

      if (!res.ok) {
        if (data.redirect === "confirmacao_email") {
          saveToGlobalState({
            ["confirmation_token"]: data.confirmation_token,
          });
          setShowLoginModal(false);
          navigate("/confirmacao-email", {
            state: {
              email: data.email,
              telefone: data.telefone,
              phone_confirmation: data.phone_confirmation,
            },
          });
          return;
        }

        if (data.redirect === "confirmacao_telefone") {
          saveToGlobalState({
            ["confirmation_token"]: data.confirmation_token,
          });
          setShowLoginModal(false);
          navigate("/confirmacao-telefone", {
            state: { telefone: data.telefone },
          });
          return;
        }

        setError(data.detail || "Erro no login");
        setSenha("");
        return;
      }

      setAccessToken(data.access);
      setUser(data.user);
      setShowLoginModal(false);

      if (dataStorage?.tab_login == "CLIENTE") {
        navigate("/dashboard-client");
        return;
      } else if (dataStorage?.tab_login == "VIAJANTE") {
        navigate("/dashboard-traveler");
        return;
      } else if (dataStorage?.tab_login == "DESTINATÁRIO") {
        navigate("/dashboard-receiver");
        return;
      } else if (dataStorage?.tab_login == "MALA") {
        navigate("/qual-meio-transporte");
        return;
      } else if (dataStorage?.tab_login == "COMPRAR") {
        console.log(dataStorage);
        console.log(dataStorage?.payload);
        if (dataStorage?.payload) {
          const response = await fetch(
            `${API_URL}/api/create-trip-negotiations/`,
            {
              method: "POST",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
                ...(data.access
                  ? { Authorization: `Bearer ${data.access}` }
                  : {}),
              },
              body: JSON.stringify(dataStorage?.payload),
            },
          );
        }

        removeSpecificData("payload");
        navigate("/dashboard-client");
        return;
      }

      navigate("/dashboard-client");
    } catch {
      setError("Erro de conexão");
      setSenha("");
    } finally {
      setLoading(false);
    }
  };

  return {
    email,
    setEmail,
    senha,
    setSenha,
    loading,
    error,
    setError,
    handleLogin,
  };
}
